<script>
  import Header from "./components/Header.svelte";
  import Footer from "./components/Footer.svelte";
  import CreatePollForm from "./components/CreatePollForm.svelte";
  import PollList from "./components/PollList.svelte";
  import Tabs from "./shared/Tabs.svelte";

  // tabs
  let items = ["Current Polls", "Add New Poll"];
  let activeItem = items[0];
  const tabChange = (e) => {
    activeItem = e.detail;
  };

  // handle the custom event "add"
  const handleAdd = () => {
    activeItem = items[0];
  };
</script>

<div>
  <div class="container-vertical">
    <div class="container-vertical-content">
      <header>
        <div class="container">
          <Header on:tabChange={tabChange} />
        </div>
      </header>
      <div class="container">
        <main>
          <Tabs {activeItem} {items} on:tabChange={tabChange} />
          {#if activeItem === items[0]}
            <PollList />
          {:else if activeItem === items[1]}
            <CreatePollForm on:add={handleAdd} />
          {/if}
        </main>
      </div>
    </div>
  </div>
  <div class="container">
    <Footer />
  </div>
</div>

<style>
  header {
    background-color: #f8f8f8;
    color: #333;
    padding: 15px 0;
    margin-bottom: 40px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0);
    border-bottom: 1px solid rgba(0, 0, 0, 0);
  }
  .container {
    max-width: 960px;
    margin: 0 auto;
    padding: 0 20px;
  }
  .container-vertical {
    display: flex;
    flex-direction: column;
    min-height: calc(100vh - 280px);
  }
  .container-vertical-content {
    flex-grow: 1;
  }
</style>
